
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/adesione-B2C",
      function () {
        return require("private-next-pages/adesione-B2C/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/adesione-B2C"])
      });
    }
  